import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { inject, observer } from 'mobx-react';
import { IconeCarregar } from '../../comum/components/Icones';
import BloqueioBlCard from './BloqueioBlCard';
import LoadingImage from '../../comum/components/LoadingImage';
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

@inject("store")
@observer
export default class TabelaBloqueioBl extends Component {
    
    constructor(props){
        super(props)

        this.controller = this.props.controller;
        
        window.addEventListener('scroll', HeaderTableFixed);
    }
    
    render() {
        if(this.controller.loading) {
            return (<Row>
                <Col xs={12}>
                    <LoadingImage />
                </Col>
            </Row>)
        } else {
            return(
                <React.Fragment>
                    {this.controller.bloqueios.length === 0
                    ?
                    <Row>
                        <Col xs={12}>
                            <span className="mensagem-filtrar">
                                {this.controller.tableMessage}
                            </span>
                        </Col>
                    </Row>
                    :
                    <InfiniteScroll
                        dataLength={this.controller.itens.length}
                        next={() => this.controller.loadNextTurn()}
                        hasMore={this.controller.hasMore}
                        loader={<LoadingImage />}
                    >
                        <ToolkitProvider
                            keyField="NumeroBl"
                            data={[...this.controller.itens]}
                            columns={[...this.controller.colunas]} >
                            {props => <div>
                                { window.innerWidth > 991
                                ?
                                <div id="tableHeaderFixed" className="tabela-overflow">
                                    <BootstrapTable  bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={()=><IconeCarregar tamanho="2x" />}
                                        classes="tabela tabela-layout"
                                        {...props.baseProps}
                                    />
                                </div>
                                :<Row>
                                    {this.controller.itens.map((card, x) => (
                                        <BloqueioBlCard
                                            controller={this.controller}
                                            key={x}
                                            data={card}
                                            id={x}
                                            colunas={[...this.controller.colunas]}
                                            titulo={"NumeroBl"}
                                            subtitulo={"Operconcat"}
        
                                        />
                                    )) }
                                </Row>
        
                                }
                            </div>}
                        </ToolkitProvider>
                    </InfiniteScroll>
                    }
                </React.Fragment>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/bloqueiobl/components/TabelaBloqueioBl.js